export default __webpack_public_path__ + "static/media/bannerIntro.6f1570ad.jpg";